import subscriptionStatus from "constants/subscriptionStatus";

const isSubscriptionActive = (subscription) =>
  subscription?.subscriptionStatus === subscriptionStatus.ACTIVE ||
  subscription?.subscriptionStatus === subscriptionStatus.FREETRIAL;

export default isSubscriptionActive;
